import camelcaseKeys from "camelcase-keys";
import { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { API_HOST } from "../config";
import { LoadingContainer } from "../containers/LoadingContainer";
import history from "../history";
import { ITalk } from "../interfaces";
import { checkAuthToken } from "../modules/auth";
import axios from "../modules/axiosInstance";

interface ITalkList {
  talks: ITalk[];
  sinceID: number;
  stage: "willMount" | "didMount";
}

const useTalkListContainer = () => {
  const [talks] = useState<ITalk[]>([]);
  const [talkList, setTalkList] = useState<ITalkList>({
    talks,
    sinceID: 0,
    stage: "willMount"
  });
  const loading = LoadingContainer.useContainer();

  const fetchTalks = () => {
    loading.start();
    const url = `${API_HOST}/api/talks`;
    axios
      .get(url)
      .then(results => {
        const data = results.data;
        const getTalks = data.map((d: object[]) => {
          return camelcaseKeys(d, { deep: true });
        });
        setTalkList({
          talks: getTalks,
          sinceID:
            getTalks[0].latestMessage !== null
              ? getTalks[0].latestMessage.id
              : 0,
          stage: "didMount"
        });
        loading.done();
      })
      .catch(e => {
        loading.done();
        console.error(e);
        history.push("/login");
      });
  };

  const updateTalks = (newTalks: any): void => {
    // トークに更新がなければすぐ返す。
    if (newTalks.length === 0) {
      return;
    }

    setTalkList({
      ...talkList,
      talks: mergeTalks(talkList.talks, newTalks),
      sinceID:
        newTalks[0].latestMessage !== null ? newTalks[0].latestMessage.id : 0
    });
  };

  const mergeTalks = (prev: ITalk[], updated: ITalk[]) => {
    const prevTalkStore = prev;
    for (let i = 0; i < prev.length; i++) {
      for (let j = 0; j < updated.length; j++) {
        // ユーザーがトークを更新していたら、過去のトーク状態を削除する。
        if (prev[i].user.id === updated[j].user.id) {
          prevTalkStore.splice(i, 1);
        }
      }
    }

    return updated.concat(prevTalkStore);
  };
  // コンポーネントの描画前に "一度だけ" リクエストを送る。
  useEffect(() => {
    if (talkList.stage === "willMount" && checkAuthToken()) {
      fetchTalks();
    }
  }, []);

  return { fetchTalks, talkList, setTalkList, updateTalks };
};

export const TalkListContainer = createContainer(useTalkListContainer);
